import { connect } from 'react-redux';
import { SEARCH } from 'constants/filter-sets';
import { filterSetFilters } from 'redux/saga/selectors';
import { injectIntl } from 'react-intl';
import { deepExtract } from 'helpers/deep';
import { decorateWith, withName } from 'helpers/decorator';
import { searchFilterActions } from './filters.helpers';
import { AUTO_RADIUS_ID, FILTER_NAMES } from '../Search.constants';
import { RadiusFilterOptions } from '../components/filters/RadiusFilterOptions';
import { loadRadius } from './filters.saga';

const { setFilterValue } = searchFilterActions;
const { RADIUS } = FILTER_NAMES;
const setRadiusFilterValue = (value, options) => setFilterValue(RADIUS, value, options);

export const mapStateToProps = state => {
  const filters = filterSetFilters(state, SEARCH);
  const itemsById = deepExtract('radius.itemsById', filters, {});
  const selectedId = deepExtract(`${RADIUS}.value`, filters, AUTO_RADIUS_ID);

  return {
    items: itemsById ? Object.values(itemsById) : [],
    selectedId,
  };
};

export const mapDispatchToProps = {
  onSelect: setRadiusFilterValue,
  loadRadius,
};

export const RadiusFilterOptionsContainer = decorateWith(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('RadiusFilterOptionsContainer')
)(RadiusFilterOptions);
